<template>
  <div class="go-img-box" @click="go">
    <img loading="lazy" :src="imgSrc" alt="">
    <div class="img-bottom" :class="{'is-gray': isGray, 'is-small': isSmall}">
      <div class="img-desc">{{ desc }}</div>
      <img :src="isGray ? arrowBlack : arrowWhite" alt="">
    </div>
  </div>
</template>
<script>
import arrowWhite from '@/assets/dashboard/arrow-white.png'
import arrowBlack from '@/assets/dashboard/arrow-black.png'
export default {
  props: {
    imgSrc: {
      type: [String, Object],
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    isGray: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      arrowBlack,
      arrowWhite
    }
  },
  methods: {
    go () {
      this.$router.push(this.path)
    }
  }
}
</script>
<style lang="scss" scoped>
.go-img-box {
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
  }
}
.img-bottom {
  position: absolute;
  width: 100%;
  height: 90px;
  bottom: 0;
  background: rgba(255,255,255,0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .img-desc {
    font-size: 32px;
    color: #16212A;
    font-weight: 600;
    line-height: 90px;
    margin-left: 30px;
  }
  img {
    width: 90px;
    height: 90px;
  }
}
.is-small {
  height: 76px;
  img {
    width: 76px;
    height: 76px;
  }
}
.is-gray {
  background: rgba(255,255,255,0.4);
}
</style>
